module.exports = __webpack_public_path__ + "img/border_radio.c0726f59.svg";